import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Mail, Flame, ShieldCheck } from "lucide-react";
import { COMPANY, NAV_LINKS } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-brand-navy text-slate-200" data-testid="site-footer">
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="grid place-items-center w-11 h-11 bg-white/10 rounded-sm">
              <Flame className="w-6 h-6 text-brand-orange" />
            </span>
            <span className="font-heading font-black text-2xl text-white tracking-tight">
              EL-Gas <span className="text-brand-orange">&amp;</span> Plumbing
            </span>
          </div>
          <p className="text-sm leading-relaxed text-slate-300 max-w-xs">
            Gas Safe registered local engineers serving Lower Clapton, Hackney, Islington and
            wider East London. Trusted, certified and dispatched fast.
          </p>
          <div className="mt-5 inline-flex items-center gap-2 bg-white/10 px-3 py-2 rounded-sm text-xs font-bold tracking-wide">
            <ShieldCheck className="w-4 h-4 text-brand-orange" />
            Gas Safe No. {COMPANY.gasSafeNumber}
          </div>
        </div>

        <div>
          <h4 className="overline mb-4">Navigate</h4>
          <ul className="space-y-2">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-sm font-semibold hover:text-brand-orange transition-colors"
                  data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="overline mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 text-brand-orange mt-1" />
              <a href={`tel:${COMPANY.phoneTel}`} className="font-bold hover:text-brand-orange" data-testid="footer-phone-link">
                {COMPANY.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-brand-orange mt-1" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-brand-orange">{COMPANY.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-brand-orange mt-1" />
              <span>{COMPANY.address}</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="overline mb-4 flex items-center gap-2">
            <Clock className="w-4 h-4" /> Hours
          </h4>
          <ul className="space-y-2 text-sm">
            {COMPANY.hours.map((h) => (
              <li key={h.day} className="flex justify-between gap-4 border-b border-white/10 pb-2">
                <span className="font-semibold">{h.day}</span>
                <span className="text-slate-300">{h.time}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-400">
          <div className="flex flex-col md:flex-row items-center gap-1 md:gap-3 text-center md:text-left">
            <p>© {new Date().getFullYear()} EL-Gas and Plumbing. All rights reserved.</p>
            <span className="hidden md:inline text-white/20">·</span>
            <p>
              Website development by{" "}
              <a
                href="https://mubashircliniccare.wordpress.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="font-bold text-brand-orange tracking-wide hover:underline"
                data-testid="footer-dev-credit-link"
              >
                MubashirDigitalCare
              </a>
            </p>
          </div>
          <p className="font-semibold tracking-wide">
            Built for the residents of Lower Clapton · Hackney · Islington · E5
          </p>
        </div>
      </div>
    </footer>
  );
}
